import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { FileUpload, FileUploadSelectEvent } from "primereact/fileupload";
import { useMemo, useRef, useState } from "react";

interface VariableEnvironnement {
  value: string;
  name: string;
}

interface UploadEnvironnementVar {
  onChange: (value: VariableEnvironnement[]) => void;
  existingEnvVar: VariableEnvironnement[];
}

enum ImportCase {
  DUPLICATED_KEY_FILE,
  DUPLICATED_KEY_WIDGET,
  EMPTY,
}

interface Idialog {
  open: boolean;
  case: ImportCase;
}

const UploadEnvironnementVar = ({
  onChange,
  existingEnvVar,
}: UploadEnvironnementVar) => {
  const fileUploadRef = useRef(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [dialog, setDialog] = useState<Idialog>({
    open: false,
    case: ImportCase.DUPLICATED_KEY_WIDGET,
  });

  const messageAndTitle: { title: string; message: string } = useMemo(() => {
    let message = "",
      title = "";
    switch (dialog.case) {
      case ImportCase.DUPLICATED_KEY_FILE:
        message =
          "Au moins une variable d'environnement est dupliquée dans le fichier que vous essayez d'importer !";
        title = "Variables dupliquées";
        break;
      case ImportCase.DUPLICATED_KEY_WIDGET:
        message =
          "Au moins une variable d'environnement est dupliquée dans le fichier que vous essayez d'importer !";
        title = "Variables dupliquées";
        break;
      case ImportCase.EMPTY:
        message = `Vérifiez que les lignes du fichier sont de type : key=value`;
        title = "Aucune donnée importée";
    }
    return { message, title };
  }, [dialog]);

  const valueIcon: string = useMemo(() => {
    if (loading) return "pi pi-spin -pi-spinner";
    return "pi pi-fw pi-images";
  }, [loading]);

  const chooseOptions = {
    icon: valueIcon,
    iconOnly: false,
    className: "custom-choose-btn p-button-text",
    label: "IMPORTER UNE LISTE DE VALEURS",
  };

  const CheckIfImportedValuesAreAlreadyInRuntimeVar = (
    importedVar: Set<string>,
    tabVarEnvImported: VariableEnvironnement[]
  ): boolean => {
    for (let i = 0; i < tabVarEnvImported.length; i++) {
      const { name } = tabVarEnvImported[i];

      if (importedVar.has(name)) {
        return true; // Duplicate name found
      }
    }

    return false;
  };

  const clearImport = () => {
    if (fileUploadRef.current) {
      // @ts-ignore
      fileUploadRef.current.clear();
    }
  };

  const onTemplateSelect = (e: FileUploadSelectEvent) => {
    setLoading(true);
    const files = e.files[0];
    console.log(e.files);
    const reader = new FileReader();

    reader.onload = (e) => {
      const tabVarEnvImported: VariableEnvironnement[] = [];
      // @ts-ignore
      const fileContent = e.currentTarget.result;
      //split line break in file content and in the lines only accept format key = value
      const lines: string[] = fileContent
        .split(/[\r\n]+/)
        .filter((line: any) =>
          /^(?!#)\s*([^=\s]+)\s*=\s*([^=\s]+)\s*$/gm.test(line)
        );
      const namesSet = new Set<string>();
      if (lines.length === 0) {
        setDialog({
          open: true,
          case: ImportCase.EMPTY,
        });
      }
      for (const line of lines) {
        const values = line.split("=");
        //Add new key = value in the store
        if (values && values[0] && values[1]) {
          if (namesSet.has(values[0])) {
            setDialog({
              open: true,
              case: ImportCase.DUPLICATED_KEY_FILE,
            });
            setLoading(false);

            clearImport();
            return;
          }
          tabVarEnvImported.push({
            name: values[0],
            value: values[1],
          });
          namesSet.add(values[0]);
        }
      }
      if (
        !CheckIfImportedValuesAreAlreadyInRuntimeVar(namesSet, existingEnvVar)
      ) {
        onChange(tabVarEnvImported);
      } else {
        setDialog({
          open: true,
          case: ImportCase.DUPLICATED_KEY_WIDGET,
        });
      }
      clearImport();
      setLoading(false);
    };

    if (files) {
      reader.readAsText(files);
    }
  };

  return (
    <>
      <div>
        <Dialog
          header={messageAndTitle.title}
          footer={
            <Button
              label={"FERMER"}
              disabled={false}
              onClick={() => {
                setDialog((val) => {
                  return {
                    open: false,
                    case: val.case,
                  };
                });
              }}
              className="mr-3 p-button-outlined p-button-sm"
            />
          }
          visible={dialog.open}
          style={{ width: "25vw" }}
          modal
          onHide={() => {
            setDialog((val) => {
              return {
                open: false,
                case: val.case,
              };
            });
          }}
        >
          <div>{messageAndTitle.message}</div>
        </Dialog>

        <FileUpload
          ref={fileUploadRef}
          mode="basic"
          multiple={false}
          accept=".properties"
          maxFileSize={1000000}
          onSelect={onTemplateSelect}
          disabled={loading}
          chooseOptions={chooseOptions}
        />
      </div>
    </>
  );
};

export default UploadEnvironnementVar;
